import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BlockedUsersConfiguration, RuleSetV2, SimpleTableService } from '@coin/shared/core/util-models';
import { Observable } from 'rxjs';
import { environment } from '@coin/shared/core/util-environments';
import { HttpHelpersService } from './http-helpers';
import { LoadingService } from './loading/loading.service';

@Injectable({
  providedIn: 'root'
})
export class BlockedUsersService implements SimpleTableService {
  private httpClient = inject(HttpClient);
  private loadingService = inject(LoadingService);
  private httpHelper = inject(HttpHelpersService);

  private readonly adminRoute = '/admin/api/v2/master/users/blocked-users-configurations';

  queryPagedAndFilteredData(): Observable<BlockedUsersConfiguration[]> {
    return this.httpClient
      .get<BlockedUsersConfiguration[]>(`${environment.api.baseUrl}${this.adminRoute}`)
      .pipe(
        this.loadingService.withLoadingScreen,
        this.httpHelper.handleError('Cannot get blocked users configuration')
      );
  }

  createBlockedUsersConfiguration(args: { name: string; ruleSet: RuleSetV2 }): Observable<BlockedUsersConfiguration[]> {
    return this.httpClient
      .post<BlockedUsersConfiguration[]>(`${environment.api.baseUrl}${this.adminRoute}`, args)
      .pipe(
        this.loadingService.withLoadingScreen,
        this.httpHelper.handleError('Cannot create blocked users configuration')
      );
  }

  updateBlockedUsersConfiguration(
    id: string,
    args: { name: string; ruleSet: RuleSetV2 }
  ): Observable<BlockedUsersConfiguration[]> {
    return this.httpClient
      .put<BlockedUsersConfiguration[]>(`${environment.api.baseUrl}${this.adminRoute}/${id}`, args)
      .pipe(
        this.loadingService.withLoadingScreen,
        this.httpHelper.handleError('Cannot update blocked users configuration')
      );
  }

  deleteBlockedUsersConfiguration(id: string): Observable<BlockedUsersConfiguration[]> {
    return this.httpClient
      .delete<BlockedUsersConfiguration[]>(`${environment.api.baseUrl}${this.adminRoute}/${id}`)
      .pipe(
        this.loadingService.withLoadingScreen,
        this.httpHelper.handleError('Cannot delete blocked users configuration')
      );
  }
}
